import React from "react";
import { Link } from "react-router-dom";
import "./NavMenu.scss";

import NavItem from "./NavItem";

import feed from "!svg-inline-loader!./images/feed.svg";
import add from "!svg-inline-loader!./images/add.svg";
import moderation from "!svg-inline-loader!./images/moderation.svg";
import buy from "!svg-inline-loader!./images/buy.svg";
import category from "!svg-inline-loader!./images/category.svg";
import exit from "!svg-inline-loader!./images/exit.svg";
import history from "!svg-inline-loader!./images/history.svg";
import news from "!svg-inline-loader!./images/news.svg";
import pay from "!svg-inline-loader!./images/pay.svg";

import * as urls from "../../utils/urls";
import * as perm from "../../utils/perm";

import IfPermission from "../../components/IfPermission";

const NavMenu = ({ onLogoutClick, moderationCount }) => (
  <div className="nav-menu">
    <Link className="nav-menu__logo" to="/" />

    <div className="nav-menu__items">
      <div className="nav-menu__items-list">
        <NavItem icon={feed} href={urls.teaserList()}>
          Лента
        </NavItem>
        <IfPermission checker={perm.canAddTeaser}>
          <NavItem icon={add} href={urls.teaserAdd()}>
            Добавить
          </NavItem>
        </IfPermission>
        <IfPermission checker={perm.canModerateAny}>
          <NavItem
            icon={moderation}
            href={urls.moderate()}
            notification={moderationCount}
          >
            Проверка
          </NavItem>
        </IfPermission>
        <IfPermission checker={perm.canViewPayoutStatus}>
          <NavItem icon={pay} href={urls.pay()}>
            Оплата
          </NavItem>
        </IfPermission>
        <IfPermission checker={perm.canViewBuyout}>
          <NavItem icon={buy} href={urls.buy()}>
            Выкуп
          </NavItem>
        </IfPermission>
        <IfPermission checker={perm.canViewChangelog}>
          <NavItem icon={history} href={urls.log()}>
            История
          </NavItem>
        </IfPermission>
        <IfPermission checker={perm.canViewNews}>
          <NavItem icon={news} href={urls.news()}>
            Новости
          </NavItem>
        </IfPermission>
        <IfPermission checker={perm.canViewCategories}>
          <NavItem icon={category} href={urls.categories()}>
            Категории
          </NavItem>
        </IfPermission>
        <NavItem icon={exit} href="#" onClick={onLogoutClick}>
          Выход
        </NavItem>
      </div>
    </div>
  </div>
);

export default NavMenu;
